export function clearProp (p) {
  p.Value = ''
}
